import React, { useEffect } from "react";
import styles from "./trainingSubscriptions.module.css";
import CampOffer from "../../../containers/campOffer/campOffer";

function TrainingSubscriptions(props) {
  useEffect(() => {
    
    // Add these detailed logs
    props.academy?.locations?.forEach(location => {
      console.log('Location name:', location.name);
      console.log('Location split:', location.name.split("Pack")[0].toLowerCase().trim());
      
      props.academy?.subscriptions?.plans?.forEach(plan => {
        console.log('Plan pack_type:', plan.pack_type);
        console.log('Comparison result:', 
          plan.pack_type.trim() === location.name.split("Pack")[0].toLowerCase().trim()
        );
      });
    });
  }, [props.academy]);

  const bookNowClickedHandler = (plan, location) => {
    if (!props.isAuthenticated) props.setShowLoginForm(true)
    else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      props.setShowAcademyRegistrationForm(true);
      props.setSelectedPlan(plan);
      props.setSelectedLocation(location)
    }
  }

  // Add a mapping object for location types
  const locationTypeMap = {
    'starter': {
      en: 'Starter Pack',
      ar: 'حزمة المبتدئين'
    },
    'advanced': {
      en: 'Advanced Pack',
      ar: 'حزمة متقدمة'
    }
  };

  const getLocationType = (locationName) => {
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;
    
    // Check each type in our map
    for (const [type, names] of Object.entries(locationTypeMap)) {
      if (locationName.includes(isEnglish ? names.en : names.ar)) {
        return type;
      }
    }
    return null;
  };

  // Add price formatter helper
  const formatPrice = (price) => {
    return Math.floor(price);
  };

  return (
    <section className={styles.trainingSubscriptions}>
      <h2 className={styles.sectionTitle}>
        {parseInt(localStorage.getItem('language')) === 1 
          ? "Training Subscriptions" 
          : "اشتراكات التدريب"}
      </h2>
      {/* Commented out section translated for reference
      <p className={styles.description}>
        {parseInt(localStorage.getItem('language')) === 1 
          ? "If your kids are between 4 and 16 years old, they can join us in 3 locations:"
          : "إذا كان عمر أطفالك بين 4 و 16 سنة، يمكنهم الانضمام إلينا في 3 مواقع:"}
      </p> */}
      {props.academy?.locations?.map((location, index) => (
        <div key={location.id} className={styles.locationSection}>
          <h3 className={styles.locationTitle}>
            {parseInt(localStorage.getItem('language')) === 1 
              ? `${index + 1} - ${location.name}`
              : `${index + 1} - ${location.name}`}
          </h3>
          <div className={styles.planGrid}>
            {props.academy?.subscriptions?.plans?.filter((plan) => {
              const locationType = getLocationType(location.name);
              return plan.pack_type === locationType;
            }).map((plan) => (
              <div key={`${location.id}-${plan.id}`}>
                <CampOffer 
                  {...plan}
                  price={formatPrice(plan.price)} 
                  clicked={() => bookNowClickedHandler(plan, location)} 
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

export default TrainingSubscriptions;
